import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "capital-gains-tax__message" }

import { type PropType } from 'vue';

import usePromise from '@exchange/libs/composables/shared/src/lib/usePromise';
import { modalVariant, type ModalVariant } from '@exchange/libs/modals/src';


export default /*#__PURE__*/_defineComponent({
  __name: 'CapitalGainsTaxAcknowledgement',
  props: {
  accept: { type: Function as PropType<() => Promise<void>>, required: true },
  variant: { type: String as PropType<ModalVariant>, default: modalVariant.dark },
},
  setup(__props) {

const props = __props;

const { loading: accepting, createPromise: acceptNow } = usePromise(props.accept);

return (_ctx: any,_cache: any) => {
  const _component_x_button = _resolveComponent("x-button")!
  const _component_x_modal = _resolveComponent("x-modal")!

  return (_openBlock(), _createBlock(_component_x_modal, {
    class: "capital-gains-tax",
    "can-close": false,
    wide: true,
    variant: __props.variant,
    title: _ctx.$t('ui.capitalGainsTax.title')
  }, {
    content: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t('ui.capitalGainsTax.message')), 1)
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_x_button, {
        variant: "primary",
        loading: _unref(accepting),
        disabled: _unref(accepting),
        onClick: _unref(acceptNow)
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('fundamentals.agree')), 1)
        ]),
        _: 1
      }, 8, ["loading", "disabled", "onClick"])
    ]),
    _: 1
  }, 8, ["variant", "title"]))
}
}

})